import { useEffect } from 'react';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import ErrorPage from '../crm_ui/error/ErrorPage';
// @ts-expect-error could not find a declaration file for module
import { AsyncComponentErrorHandler } from 'customer-data-sidebar/async';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const getRouteErrorComponent = routeName => function RouteErrorComponent({
  error
}) {
  useEffect(() => {
    AsyncComponentErrorHandler(routeName)(error);
  }, [error]);
  return /*#__PURE__*/_jsx(ErrorPage, {
    errorCode: "400"
  });
};
export const makeAsyncRoute = (loader, routeName) => Loadable({
  loader,
  LoadingComponent: function DefaultLoader() {
    return /*#__PURE__*/_jsx(LoadingOverlay, {});
  },
  ErrorComponent: getRouteErrorComponent(routeName)
});